var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnegIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.32,
    height: 61.23,
    viewBox: "0 0 64.32 61.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #191919;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.16,.49L18.07,29.79V1.58c0-.88-.71-1.58-1.58-1.58H1.58C.71,0,0,.71,0,1.58V59.64c0,.88,.71,1.58,1.58,1.58h6.6c.44,0,.86-.18,1.16-.5L63.88,2.67c.95-1.01,.23-2.67-1.16-2.67h-15.42c-.43,0-.85,.18-1.14,.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.32,35.6l-10.02,10.67,13.87,14.47c.3,.31,.71,.49,1.14,.49h15.42c1.39,0,2.11-1.66,1.16-2.67l-21.57-22.96Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnegIcon);
export default __webpack_public_path__ + "static/media/kneg-icon.4438fe7358b871401becb6d17a8a7bd9.svg";
export { ForwardRef as ReactComponent };